import { styled } from 'styled-components';

import { Container, Row } from 'react-bootstrap';

import { useSelector } from 'react-redux';
import * as store from '../../../../reducers/store';

import { api } from 'common';

import {
  ORGANIZATION_ID_TO_REPUTATION_TENANT_CODE,
  StyledBorder,
  StyledHeaderSmall,
} from '../Common';

interface Props {
  provider: api.PrevisitProvider.SafeProviderWithPractices;
  organizationId: string;
  reviewsRef?: React.RefObject<HTMLDivElement>;
}

const Reviews: React.FC<Props> = ({ provider, organizationId, reviewsRef }) => {
  const embedded = useSelector((store: store.All) => store.embedded);
  const reputationTenantCode: string | undefined =
    ORGANIZATION_ID_TO_REPUTATION_TENANT_CODE[organizationId];
  if (!provider.preference?.reputationId || !reputationTenantCode) {
    return null;
  }
  const getReviews = () => {
    return (
      <>
        <EmbeddedReputationWidget
          className="mb-2"
          src={`https://widgets.reputation.com/widgets/${provider.preference?.reputationId}/run?tk=${reputationTenantCode}`}
          title="Embedded reputation.com reviews widget"
        />
        <ReputationReviewsLink
          className="text-decoration-none"
          href={`https://widgets.reputation.com/widgets/${provider.preference?.reputationId}/run?tk=${reputationTenantCode}`}
          target="_blank"
        >
          Reputation Reviews
        </ReputationReviewsLink>
      </>
    );
  };

  const content = (
    <>
      <StyledHeaderSmall variant="headline-small" bold>
        Reviews
      </StyledHeaderSmall>
      <Row className="mx-0">{getReviews()}</Row>
    </>
  );

  return (
    <>
      <StyledBorder />
      {embedded ? (
        <div ref={reviewsRef}>{content}</div>
      ) : (
        <Container ref={reviewsRef}>{content}</Container>
      )}
    </>
  );
};

export default Reviews;

const EmbeddedReputationWidget = styled.iframe`
  width: calc(100% + 20px);
  height: 300px;
  margin-left: -10px;
`;

const ReputationReviewsLink = styled.a`
  color: var(--color-primary);
  :hover {
    text-decoration: underline !important;
  }
`;
